'use strict';

export default race;
import Promise from './promise';

/**
  This is a convenient alias for `RSVP.Promise.race`.

  @method race
  @static
  @for RSVP
  @param {Array} array Array of promises.
  @param {String} label An optional label. This is useful
  for tooling.
 */
function race(array, label) {
  return Promise.race(array, label);
}